export default "__VITE_ASSET__BXBN7MVR__"